<div class="quick-order-actions">
  <div
    class="button-wrapper"
    matTooltip="{{ 'buttonTooltip.quickOrder.deleteAllButton' | cxTranslate }}"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="'button-tooltip'"
    aria-label="displays a tooltip in bottom"
    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
  >
    <button
      class="btn tertiary-btn"
      type="button"
      (click)="clearAll()"
      [attr.disabled]="entries.length === 0 ? 'disabled' : null"
    >
      <mat-icon svgIcon="deletecart"></mat-icon>
    </button>
  </div>
  <div
    class="button-wrapper"
    matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="'button-tooltip'"
    aria-label="displays a tooltip in bottom"
    [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
  >
    <button
      class="btn btn-primary"
      type="button"
      (click)="backOrderCheck(entries)"
      [attr.disabled]="
        cartDisable || !hasAtLeastOneDealerPrice(entries) || entries.length === 0 || showSrp ? 'disabled' : null
      "
      [ngClass]="{
        rotating: addToCartInprogress
      }"
    >
      @if (!addToCartInprogress) {
      <mat-icon svgIcon="add-to-cart"></mat-icon>
      } @else { }
    </button>
  </div>
</div>
@if (entries.length > 0) {
<div class="quick-order-entries">
  @for (entry of entries; track entry; let index = $index) {
  <div class="quick-order-entry">
    <button type="button" class="close" aria-label="Close" (click)="deleteEntry(index)">
      <mat-icon
        matTooltip="{{ 'buttonTooltip.quickOrder.deleteEntry' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="icon-tooltip"
        aria-label="displays a tooltip in bottom"
        svgIcon="x-icon"
      ></mat-icon>
    </button>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'cart.quickOrder.queryProduct.input' | cxTranslate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'cart.quickOrder.queryProduct.placeholder' | cxTranslate }}"
        [value]="entry.code"
        disabled
      />
    </mat-form-field>
    <div class="entry">
      <div class="image">
        <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: entry } | cxUrl">
          @if (entry?.images) {
          <cx-media
            [container]="getImageRendition((entry?.images)[0])"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
          } @else {
          <cx-media
            class="cx-no-image is-missing"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
          }
        </a>
      </div>
      <div class="entry-info">
        <div class="code">
          {{ entry.code }}
          @if (entry?.manualAllocation && manualAllocationEnabled) {
          <span class="no-stock">
            <div>{{ 'product.noStock' | cxTranslate }}</div>
          </span>
          } @else { @if (entry?.inStockFlag === true) {
          <span class="in-stock">
            <div>{{ 'product.inStock' | cxTranslate }}</div>
          </span>
          } @if (entry?.inStockFlag === false) {
          <span class="no-stock">
            <div>{{ 'product.noStock' | cxTranslate }}</div>
          </span>
          } }
        </div>
        <div class="name" [innerHTML]="entry.name"></div>
        @if (entry?.superCategories) {
        <div class="global-variant" [class.ofBy-present]="entry?.replacementOf && entry?.replacedBy">
          @for (variant of checkVariant(entry?.superCategories); track variant; let index = $index; let last = $last) {
          @if (!last) {
          {{ variant.parentCategoryName }}: {{ variant.name }}; } @else { {{ variant.parentCategoryName }}:
          {{ variant.name }}
          } }
        </div>
        }
        <!-- TABLET MODE ONLY-->
        @if (entry?.replacementOf) {
        <div class="replacement-tablet-only" [class.mt-auto]="entry?.replacementOf && entry?.replacedBy">
          <div class="replacement-of">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacementOf' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry.replacementOf } | cxUrl">{{
                entry?.replacementOf?.code
              }}</a>
            </div>
          </div>
          @if (!entry?.replacementOf && entry?.replacedBy) {
          <div class="replaced-by">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry.replacedBy } | cxUrl">
                {{ entry?.replacedBy?.code }}
              </a>
            </div>
          </div>
          }
        </div>
        }
      </div>
      <div class="entry-price" [ngClass]="{ 'entry-with-notify-me': entry?.notifyMe }">
        <div class="entry-price-wrapper">
          <div class="dealer-price">
            <div class="label">{{ 'cart.cartItem.itemPrice' | cxTranslate }}</div>
            @if (!showSrp) {
            <div class="value">
              @if (!dealerPrice(entry.code)) {
              <div class="spinner-shimano-wrapper-dp">
                @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (hasDealerPriceOf[entry.code]) {
                <div class="spinner-shimano spinner-shimano-mr">
                  <div></div>
                </div>
                } @if (!hasDealerPriceOf[entry.code] && !tooltipIconConfig?.enabled) {
                <div class="no-dealer-price no-dealer-price-cs-cm"></div>
                } @else { @if (!hasDealerPriceOf[entry.code] && tooltipIconConfig?.enabled) {
                <app-tooltip-icon
                  [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                  dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                  placement="bottom-right"
                  [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                  [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                ></app-tooltip-icon>
                } } }
              </div>
              } @else {
              {{ dealerPrice(entry.code) }}
              @if (showGstExclusive$ | async) {
              <span class="d-block">{{ 'cart.cartItem.gstExclusive' | cxTranslate }}</span>
              } }
            </div>
            }
          </div>
          <div class="quantity">
            <input
              #quickOrderInput
              class="cx-counter-value js-quantity"
              type="number"
              [min]="min"
              [max]="max"
              [step]="step"
              [value]="entry.qty"
              (change)="
                quickOrderInput.value === '' || quickOrderInput.value < 0 ? (quickOrderInput.value = 1) : true;
                updateCount(index, quickOrderInput.value, entry)
              "
              (blur)="
                quickOrderInput.value === '' || quickOrderInput.value < 0 ? (quickOrderInput.value = 1) : true;
                updateCount(index, quickOrderInput.value, entry)
              "
              (keypress)="numberOnly($event)"
              (input)="onInput(quickOrderInput.value)"
              [class.invalid]="entry.isMoqError"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [attr.disabled]="!dealerPriceValue(entry.code) ? 'disabled' : null"
            />
            @if (entry.isMoqError) {
            <mat-error [class.gst-exclusive]="dealerPriceValue(entry.code) && showGstExclusive$ | async">
              {{ 'moq.inlineMessage' | cxTranslate : { moq: entry.minOrderQuantity } }}
            </mat-error>
            }
          </div>
          <div class="total">
            <div class="label">{{ 'cart.cartItem.total' | cxTranslate }}</div>
            @if (!showSrp) {
            <div class="value">
              @if (!dealerPrice(entry.code)) {
              <div class="spinner-shimano-wrapper-dp">
                @if (hasDealerPriceOf[entry.code]) {
                <div class="spinner-shimano spinner-shimano-mr">
                  <div></div>
                </div>
                } @if (!hasDealerPriceOf[entry.code]) {
                <div class="no-dealer-price no-dealer-price-cs-cm"></div>
                }
              </div>
              } @else {
              {{ entry.qty * dealerPriceValue(entry.code) | mycurrency }}
              @if (showGstExclusive$ | async) {
              <span class="d-block">{{ 'cart.cartItem.gstExclusive' | cxTranslate }}</span>
              } }
            </div>
            }
          </div>
        </div>
        <!-- TABLET MODE ONLY-->
        <div class="replacement-tablet-only" [class.mt-auto]="entry?.replacementOf && entry?.replacedBy">
          @if (entry?.replacedBy) {
          <div class="replaced-by">
            <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
            <div class="value">
              <a [routerLink]="{ cxRoute: 'product', params: entry?.replacedBy } | cxUrl">{{
                entry?.replacedBy?.code
              }}</a>
            </div>
          </div>
          }
        </div>
      </div>
      <div
        class="replacement-wrapper"
        [class.ofBy-present]="entry?.replacementOf && entry?.replacedBy"
        [ngClass]="{ 'replacement-with-notify-me': entry?.notifyMe }"
      >
        @if (entry?.replacementOf) {
        <div class="replacement-of">
          <div class="label">{{ 'cart.quickOrder.queryProduct.replacementOf' | cxTranslate }}</div>
          <div class="value">
            <a [routerLink]="{ cxRoute: 'product', params: entry?.replacementOf } | cxUrl">{{
              entry?.replacementOf?.code
            }}</a>
          </div>
        </div>
        } @if (entry?.replacedBy) {
        <div class="replaced-by">
          <div class="label">{{ 'cart.quickOrder.queryProduct.replacedBy' | cxTranslate }}</div>
          <div class="value">
            <a [routerLink]="{ cxRoute: 'product', params: entry?.replacedBy } | cxUrl">{{
              entry?.replacedBy?.code
            }}</a>
          </div>
        </div>
        }
      </div>
      @if (entry.notifyMe) {
      <div class="notify-me-wrapper">
        <app-notify-me [productCode]="entry.code"></app-notify-me>
      </div>
      }
    </div>
  </div>
  }
</div>
} @if (entries.length < 25) {
<div class="quick-order-form">
  <div class="entry-input" [ngClass]="{ 'error-text': queryProduct.invalid }">
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'cart.quickOrder.queryProduct.input' | cxTranslate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'cart.quickOrder.queryProduct.placeholder' | cxTranslate }}"
          formControlName="queryProduct"
          name="queryProduct"
          [formControl]="queryProduct"
          (focusout)="onKeyUp($event)"
          (keydown.enter)="$event.target.blur(); (false)"
          #skuItemNumber
        />
        @if (queryProduct.invalid) {
        <mat-error>{{ errorText }}</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</div>
}
